import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useGoogleSpreadsheetDataExport } from '../../io/GoogleV2Hooks/useGoogleSpreadsheetDataExport';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useGoogleSpreadsheetDataExportWidget = () => {
    const { components } = useGoogleSpreadsheetDataExport({
        spreadsheetData: [],
        provideExportButton: true,
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "ExportButton" }), components.ExportButton, _jsx(Typography, { variant: "h5", children: "WorkingSpinner" }), components.WorkingSpinner] })), [components]);
    return {
        name: 'useGoogleSpreadsheetDataExport',
        category: 'composite',
        component,
    };
};
